import React from 'react'
import './Footer.css'
import '../../Global.css'
function Footer() {
  return (
    <div className="footer">
        <p>&copy; Dhanyasree Gopinigari, 2026</p>
    </div>
  )
}

export default Footer